import { PublicClientApplication, type Configuration, LogLevel } from '@azure/msal-browser';
import { env } from './env.js';

const config: Configuration = {
  auth: {
    clientId: env.VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${env.VITE_MSAL_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error('[msal]', message);
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(config);

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const apiTokenRequest = {
  scopes: [env.VITE_MSAL_API_SCOPE],
};
